export type PackageTier = 'Discover' | 'Govern' | 'Protect';

// Tiers are additive: Govern includes all Discover flags, Protect includes all Govern+Discover.
// Numeric ranks let us express this as flagRank <= customerRank.
export const TIER_RANK: Record<PackageTier, number> = {
	'Discover': 1,
	'Govern': 2,
	'Protect': 3
};

export const PACKAGE_TIER_OPTIONS = [
	{ label: 'None', value: '' },
	{ label: 'Discover', value: 'Discover' },
	{ label: 'Govern', value: 'Govern' },
	{ label: 'Protect', value: 'Protect' }
];

export const TIER_TAG_COLORS: Record<PackageTier, string> = {
	Discover: 'blue',
	Govern: 'green',
	Protect: 'orange'
};

export const ORDERED_TIERS: readonly PackageTier[] = ['Discover', 'Govern', 'Protect'] as const;

export type featureFlagMetadata = {
    name: string,
    groupName?: string,
    groupId?: number,
    state: boolean,
    enabledByDefault: boolean,
    exceptionCustomers: Array<featureFlagCustomer>,
    minimumPackageTier?: PackageTier | null,
};

export type featureFlagCustomer = {
    id: number,
    name: string,
    enabled: boolean,
    shardName?: string,
};
